var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/fullscreen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,13 C5.55,13 5.997,13.444 6,13.995 L6,13.995 L6.013,16.573 L9.293,13.293 C9.684,12.902 10.316,12.902 10.707,13.293 C11.098,13.684 11.098,14.316 10.707,14.707 L10.707,14.707 L7.415,17.999 L10,18 C10.553,18 11,18.448 11,19.001 C10.999,19.553 10.552,20 10,20 L10,20 L9.999,20 L5.024,19.997 C4.474,19.997 4.028,19.552 4.025,19.002 L4.025,19.002 L3.99997005,14.005 C3.997,13.453 4.443,13.003 4.995,13 L4.995,13 L5,13 Z M14.0046,4.0004 L19.0016,4.0254 C19.5516,4.0284 19.9966,4.4744 19.9966,5.0244 L19.9966,5.0244 L19.9996034,9.9994 C20.0006,10.5514 19.5526,11.0004 19.0006,11.0004 L19.0006,11.0004 C18.4476,11.0004 18.0006,10.5524 17.9996,10.0014 L17.9996,10.0014 L17.9976,7.4164 L14.7066,10.7074 C14.5116,10.9024 14.2556,11.0004 13.9996,11.0004 C13.7446,11.0004 13.4886,10.9024 13.2926,10.7074 C12.9026,10.3164 12.9026,9.6834 13.2926,9.2934 L13.2926,9.2934 L16.5726,6.0134 L13.9956,6.0004 C13.4426,5.9974 12.9966,5.5464 12.9995701,4.9954 C13.0026,4.4444 13.4506,4.0004 13.9996,4.0004 L13.9996,4.0004 L14.0046,4.0004 Z",
    id: "path-1",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.d6a1cf07.svg";
export { ForwardRef as ReactComponent };